import VersionsList from './VersionsList';

export default VersionsList;
